<template>
  <div class="container container--hero">
    <div class="hero" v-show="!this.$store.state.showPromoData && !this.$store.state.showNoTranslationMessage">
      <div class="txt__first_line">{{ this.$store.state.labels.hero_first }}</div>
      <div class="txt__second_line">{{ this.$store.state.labels.hero_second }}</div>
      <div class="txt__third_line">{{ this.$store.state.labels.hero_third }}</div>
    </div>
    <div class="hero hero--finalData" v-show="this.$store.state.showPromoData && !this.$store.state.showNoTranslationMessage">
      <div class="txt__years">{{ this.$store.state.promoData.years }}</div>
      <div class="txt__first_line">{{ this.$store.state.promoData.first }}</div>
      <div class="txt__second_line">{{ this.$store.state.promoData.second }}</div>
      <div class="txt__third_line">{{ this.$store.state.promoData.third }}</div>
      <div class="txt__fouth_line">{{ this.$store.state.promoData.fourth }}</div>
    </div>
    <div class="hero hero--finalData hero--and" v-show="this.$store.state.showPromoComboData && !this.$store.state.showNoTranslationMessage">
      <span class="hero__and">&</span>
    </div>
    <div class="hero hero--finalData no-marginTop-mobile" v-show="this.$store.state.showPromoComboData && !this.$store.state.showNoTranslationMessage">
      <div class="txt__years">{{ this.$store.state.promoComboData.years }}</div>
      <div class="txt__first_line">{{ this.$store.state.promoComboData.first }}</div>
      <div class="txt__second_line">{{ this.$store.state.promoComboData.second }}</div>
      <div class="txt__third_line">{{ this.$store.state.promoComboData.third }}</div>
      <div class="txt__fouth_line">{{ this.$store.state.promoComboData.fourth }}</div>
    </div>
    <div class="hero hero--infoMessage" v-show="this.$store.state.showNoTranslationMessage">
      <div class="txt__info-message">If your country  is not on the list that means that no promotion is available at the moment</div>
    </div>


  </div>
</template>

<script>
import countryMng from '@/helper/country'
import { useStore } from 'vuex'
export default {
  name: 'Hero',
  data() {
    return {
      heroFirst: '',
      heroSecond: '',
      heroThird: '',
      country: '',
      name: ''
    }
  },
  mounted () {
    const store = useStore();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if ((window.location.href.includes('locale')) && (params.locale !== '')) {
      this.country = params.locale;
    } else {
      this.country = countryMng.getCountryFromReq();
    }
    this.name = countryMng.getNameFromCountry(this.$store.state.nameCountryMapping, this.country);
    store.commit('setCountry', this.country);
    store.commit('setCountryName', this.name);
  },
  created () {
  },
}
</script>
